<template>
  <v-container fluid>
    <div class="d-flex flex-column">
      <v-form ref="form" v-model="valid">
        <v-text-field v-model="lastname" label="Nom" :rules="nameRules" required></v-text-field>
        <v-text-field v-model="firstname" label="Prénom" :rules="nameRules" required></v-text-field>
        <v-text-field v-model="firm" label="Société (optionnel)"></v-text-field>
        <v-text-field v-model="mail" label="E-mail" :rules="nameRules" required></v-text-field>
        <v-checkbox v-model="accept_news" :rules="nameRules" label="Accepter les conditions" required></v-checkbox>
        <v-col cols="11">
          <v-btn :disabled="!valid" color="success" @click="validate">S'inscrire</v-btn>
        </v-col>
        <div v-if="errors.length">
          <b>Erreur:</b>
          <ul>
            <li v-for="error in errors" :key="error">{{ error }}</li>
          </ul>
        </div>
        <div v-if="status.length">
          <b>{{ status }}</b>
        </div>
      </v-form>
    </div>
  </v-container>
</template>

<script>
export default {
  data () {
    return {
      valid: false,
      errors: [],
      status: [],
      firstname: null,
      lastname: null,
      accept_news: null,
      mail: null,
      firm: null,
      nameRules: [v => !!v || 'required'],
    }
  },
  methods: {
    validate () {
      this.$refs.form.validate().then(valid => {
        if (!valid) return
        this.errors = []
        this.status = []
        this.valid = false
        var errs = this.errors
        var statuses = this.status
        this.$apiclient.addFollower(
          this.firstname, this.lastname, this.mail,
          this.firm, null, this.accept_news, 'Newsletter'
        )
          .then(response => {
            if (response.status !== 200) errs.push(response.statusText)
            statuses.push('Vous êtes bien inscrit à la Newsletter')
          })
          .catch(error => {
            if (error.response.status === 401) {
              errs.push("Vous n'êtes pas connecté ou non authorisé")
            } else {
              errs.push(error.response.statusText)
            }
          })
      })
    }
  }
}
</script>
